import { useEffect, useRef, useState } from "react";
import goodsApi from "api/goodsApi";



export const useGoods = (filerMode) => {
  const [termSearch, setTermSearch] = useState({ filterMode: filerMode || 0 });
  const [goodsList, setGoodsList] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [goods, setGoods] = useState();
  //GoodsID for show  Search GoodsSub
  const [goodsIDSelected, setGoodsIDSelected] = useState(0);
  const [goodsAdd, setGoodsAdd] = useState();

  //Goods Group Class
  const [goodsClassList, setGoodsClassList] = useState([]);
  const refTop = useRef();
  const title = !!goods?.GoodsID ? "商品明細" : "商品検索";


  // Select Goods -> show Goods Details
  const hanleSelectGoods = async (goodsID) => {
    if (!goodsID) return;

    try {
      setIsLoading(true);
      const { data } = await goodsApi.getGoodsDetails({ id: goodsID });
      setGoods({ ...data.dtGoodsInfo[0] });
    } catch (error) {
      alert(error);
    } finally {

    } setIsLoading(false);
  }

  // Change  Favorite
  const handleChangeFavorite = async (goodsID, goodsSubID, favoriteID) => {
    try {
      setIsLoading(true);
      /**Call Api */
      const { data } = await goodsApi.updateGoodsFavorite({
        goodsID: goodsID,
        goodsSubID: goodsSubID || 1,
        favoriteID: favoriteID || '',
      });
      const paramsSearch = {
        goodsName: termSearch?.txtSearch || '',
        filterMode: termSearch?.filterMode || 0, // 0: 全て, 1: お気に入りのみ, 2: 定番
        colorLevel: !!termSearch?.colorLevel,
      }
      const dtResponse = await goodsApi.searchGoods(paramsSearch);
      const dtGoods = dtResponse?.data['dtGoods'] ?? [];
      setGoodsList([...dtGoods]);
      setGoods((preValue) => ({ ...preValue, FavoriteID: data.favoriteID }));

    } catch (err) {
      alert(err);
    } finally {
      setIsLoading(false);
    }
  }

  //Add Goods to Cart
  const handleAddToCart = async (_goodsAdd) => {

    if (_goodsAdd.GoodsSubID > 1) {
      // Show Add to Cart
      setGoodsAdd({ ..._goodsAdd });
      return;
    }

    try {
      setIsLoading(true);
      /**Call Api Check GoodsSub is Exist*/
      const dtResponse = await goodsApi.getNumGoodsSub({
        goodsID: _goodsAdd.GoodsID
      });


      const numGoodsSub = dtResponse?.data['numGoodsSub'] ?? 0;
      //show search GoodsSub 
      if (!!numGoodsSub && numGoodsSub > 0) {
        setGoodsIDSelected(_goodsAdd.GoodsID);
      } else {
        // Show Add to Cart
        setGoodsAdd({ ..._goodsAdd });
      }
    } catch (err) {
      alert(err);
    } finally {
      setIsLoading(false);
    }
  }
  const handleCloseAddToCart = (_goodsAdd) => {
    setGoodsAdd(undefined)
    setGoodsIDSelected(0);
  }

  // Back from Goods Detials
  const handleBack = () => {
    setGoods(null);
  }



  //Get GoodsGroup Class
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const dtResponse = await goodsApi.getGoodsGroupClass();
        const dtGGClass = dtResponse?.data['dtGGClass'] ?? [];
        setGoodsClassList([...dtGGClass]);

      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [])

  //Search Goods
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const params = {
          goodsName: termSearch?.txtSearch || '',
          filterMode: termSearch?.filterMode || 0, // 0: 全て, 1: お気に入りのみ, 2: 定番
          colorLevel: !!termSearch?.colorLevel,
          // Convert Array to String
          goodsGroupClassIDs: (termSearch?.goodsGroupClassIDs || []).join(','),
        }

        const dtResponse = await goodsApi.searchGoods(params);
        const dtGoods = dtResponse?.data['dtGoods'] ?? [];
        setGoodsList([...dtGoods]);
        if (refTop) refTop.current.scrollTo(0, 0);
      } catch (error) {
        console.log(error);
        alert(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [termSearch])


  // Return data 
  return {
    title,
    refTop,
    termSearch,
    setTermSearch,
    goodsList,
    isLoading,
    goods,
    goodsIDSelected,
    setGoodsIDSelected,
    goodsAdd,
    hanleSelectGoods,
    handleChangeFavorite,
    handleAddToCart,
    handleCloseAddToCart,
    handleBack,
    setIsLoading,
    goodsClassList
  }
}